import React from 'react';
import PropTypes from 'prop-types';
import {RangeSlider} from '@learningblocks/shared-components';
import {SliderBlockLoader as Loader} from './SliderBlock.loader';
import cname from '../style.module.scss';

export function SliderBlock(props) {
  return (
    <div className={cname.sliderBlock}>
      {props.loading ? (
        <Loader />
      ) : (
        <div className={cname.slider}>
          {props.text && <h5 className={cname.text}>{props.text}</h5>}
          <RangeSlider
            min={props.min}
            max={props.max}
            step={props.step}
            value={props.current}
            scaleInterval={props.scaleInterval}
            inputLabel={props.ariaLabel}
            className={cname.rangeSlider}
            onChange={props.onSliderChange}
          />
        </div>
      )}
    </div>
  );
}

SliderBlock.propTypes = {
  /**
   * Text to display on top of Slider
   */
  text: PropTypes.string,
  /**
   * Scale interval to display rulers
   */
  scaleInterval: PropTypes.number,
  /**
   * min value to set on slider
   */
  min: PropTypes.number,
  /**
   * max value to set on slider
   */
  max: PropTypes.number,
  /**
   * update step value for slider
   */
  step: PropTypes.number,
  /**
   * Current frame to render
   */
  current: PropTypes.number,
  /**
   * Callback for when slider thumb in moved
   */
  onSliderChange: PropTypes.func,
  /**
   * Boolean set to show Content loader
   */
  loading: PropTypes.bool,
  /**
   * Aria-Label for input slider
   */
  ariaLabel: PropTypes.string,
};
